import React, { Component } from 'react'
import { connect } from 'react-redux'
import TVChannels from './TVChannels'
import TVButton from './TVButton'
import { fetchChannelList } from '../../../action/tvChannelAction'
import { closeOrderPopUp } from '../../action/hCommerce2';
import {withTranslation} from "react-i18next";
import { ReactComponent as SliderVertical } from "../../images/icons/sliders-vertical.svg";
import { ReactComponent as GuideList } from "../../images/icons/list.svg";

class TVRemote extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 0,
            numberPad: false
        }
    }

    componentDidMount() {
        let sessionToken = localStorage.getItem("GuestJourneySessionToken");
        let chanSchHours = parseInt(this.props.channelScheduleHours);
        if (sessionToken && chanSchHours) {
            this.props.fetchChannelList("/Ipg/ChannelData", chanSchHours, sessionToken);
        } else {
            console.log("There is no channelScheduleHours or sessionToken")
        }
    }

    changePage = (page) => {
        if (this.state.currentPage != page)
            this.setState({ currentPage: page });
    }
    render() {
        const { t } = this.props
        return (
            <div class="main-container background-overlay"
            // style="background: url('theme/images/background/08MEDubai-Atrium.jpg') center center no-repeat; background-size: cover;background-attachment: fixed;"
            style={{position:"relative"}}
            >
                {this.state.currentPage === 0 ?
                    <TVButton /> : <TVChannels />
                }
                <footer>
                    <div class="nav">
                        <a onClick={() => this.changePage(0)} style={{ padding: 0, color: "inherit" }}
                            className={this.state.currentPage == 0 ? "button selected" : "button"}>
                            <SliderVertical />
                            <span style={{ color: "inherit" }}>{t('room_control.tv_control.remote_btn')}</span>
                        </a>
                        <a onClick={() => this.changePage(1)} style={{ padding: 0, color: "inherit" }}
                            className={this.state.currentPage != 0 ? "button selected" : "button"}>
                            <GuideList />
                            <span style={{ color: "inherit" }}>{t('room_control.tv_control.guide_btn')}</span>
                        </a>
                    </div>
                </footer>
            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        roomRemoteDetails: state.store.tvChannels.roomRemoteDetails,
        currentTv: state.store.tvChannels.currentTv,
        menuColor: state.store.home.MenuColor,
        channelScheduleHours: state.store.home.clientConfig.ipgExtraInfo ?
            state.store.home.clientConfig.ipgExtraInfo.ipgBrandingInfo.channelScheduleHours : "0",
    }
}
export default connect(
    mapStateToProps,
    {
        fetchChannelList,
        closeOrderPopUp
    }
)(withTranslation('translations')(TVRemote));